export default {
    template: document.querySelector('[data-quiz-dialogue-code-template]') ?
        document.querySelector('[data-quiz-dialogue-code-template]').innerHTML:
        null,
    props: {
        question: {
            type: Object,
            required: false
        },
        copy: {
            type: Object,
            required: false
        },
        code: {
            type: String,
            required: false
        },
        codearray: {
            type: Array,
            required: false
        },
        novideo: {
            type: Boolean,
            required: false
        },
        youtubeapiloaded: {
            type: Boolean,
            required: true
        },
        audioplayed: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            audio: null,
            audioEnded: false,
            showAudioDialogue: false,

            localCode: [],
            wrongCode: false,
            closingModal: false,
            showVideoDialogue: false,
            showQuestionDialogue: false,
            videoPlayer: null,
            videoPlayed: false
        };
    },
    methods: {
        updateLocalCode(e, index) {
            this.localCode[index] = e.target.value.toUpperCase();
        },

        performCodeCheck() {
            let localCodeString = '';
            this.localCode.forEach(letter => {
                localCodeString += letter;
            });

            if (localCodeString != this.code) {
                this.wrongCode = true;
                return;
            }

            this.showQuestionDialogue = false;
            setTimeout(() => {
                this.showVideoDialogue = true;
            }, 560);

            this.$refs.videoModal.addEventListener('animationend', () => {
                if (this.youtubeapiloaded) {
                    this.playVideo();
                }
            });
        },

        checkCode(e, index) {
            let input = e.target.value;
            if (input) {
                input = input.toUpperCase();
            }

            if (input === this.codearray[index].letter) {
                this.$emit('letter-guessed-in-code', {
                    index: index,
                    correct: true,
                    guess: input
                });
                return;
            }

            this.$emit('letter-guessed-in-code', {
                index: index,
                correct: false,
                guess: input
            });
        },

        closeModal() {
            this.$refs.questionDialogue.addEventListener('animationend', () => {
                this.$emit('close-modal');
            });

            this.showQuestionDialogue = false;
        },

        focusInput(e) {
            e.target.select();
        },

        createYouTubeEmbed() {
            // create a youtube player
            this.videoPlayer = new YT.Player(this.$refs.videoPlayer, {
                height: '360',
                width: '640',
                videoId: this.question.videoId,
                playerVars: {
                    // controls: 0,
                },
                events: {
                    'onStateChange': this.onPlayerStateChange
                }
            });
        },

        playVideo() {
            this.videoPlayer.playVideo();
        },

        onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.ENDED) {
                this.$refs.videoModal.addEventListener('animationend', () => {
                    this.closeVideoModal();
                });

                this.showVideoDialogue = false;
                this.videoPlayed = true;
            }
        },

        closeVideoModal() {
            if (this.videoPlayer) {
                this.videoPlayer.destroy();
            }

            this.$emit('quiz-completed');
            this.$emit('close-modal');
        },

        /**
         * Give consent for youtube video's
         */
        giveYoutubeConsent() {
            this.$emit('youtube-consent-given');
        },

        /**
         * Create an audio object and play it
         */
        handleAudio() {
            this.audio = new Audio(this.question.audioUrl);
            this.audio.play();
            this.audio.addEventListener('ended', () => {
                this.audio = null;
                this.audioEnded = true;
            });
        },

        openQuestionModal() {
            this.showAudioDialogue = false;
            if (this.audio) {
                this.audio.pause();
            }

            this.showQuestionDialogue = true;
            this.$emit('dialogue-code-audio-played');
        },
    },
    mounted() {
        this.codearray.forEach((entry, index) => {
            if (entry.complete) {
                this.localCode[index] = entry.letter;
            }
        });

        if (this.youtubeapiloaded) {
            this.createYouTubeEmbed();
        } else {
            window.onYouTubePlayerAPIReady = () => {
                this.createYouTubeEmbed();
            };
        }

        if ( ! this.audioplayed) {
            this.showAudioDialogue = true;
            this.handleAudio();
            return;
        }

        this.openQuestionModal();
    }
}